export const CheckoutSuccess = {
  description: 'Congratulations! Your Matchcoins purchase was a success.',
  createBattleButton: 'Create a Battle',
  createTournamentButton: 'Create a Tournament'
};
